import { Box as MuiBox } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'src/types';
import {
  PaymentReviewDetails,
  PaymentReviewDetailsProps,
} from '../FormComponents/Components/PaymentReviewDetails';

interface Props {
  logo?: ReactElement;
}

const Sidebar = ({ logo }: Props) => {
  const application = useSelector((store: Store) => store.application.data);

  const [detailInfo, setDetailInfo] = useState<PaymentReviewDetailsProps>();
  const formatDate = (date: Date | string) => {
    if (date && new Date(date)) {
      return new Date(date).toLocaleString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'America/New_York',
      });
    }
    return '';
  };

  useEffect(() => {
    try {
      if (application) {
        const {
          firstName,
          lastName,
          email,
          phone,
          address,
          buildingName,
          buildingUnit,
          buildingAddress,
          COMPANY_VENDOR,
        } = application;

        const coverages = [
          {
            name: 'Property Coverage',
            cost: application.personalPropertyCoverage || 0,
          },
          {
            name: 'Personal Liability',
            cost: application.personalLiabilityCoverage || 0,
          },
          {
            name: 'Medical Liability',
            cost: application.medicalPayments || 0,
          },
          {
            name: 'Loss of Use',
            cost: application.lossOfUse || 0,
          },
          {
            name: 'Deductible',
            cost: application.deductible || 0,
          },
        ];
        if (application.theft) {
          coverages.push({
            name: 'Theft',
            cost: application.theft || 0,
          });
        }
        if (application.waterBackup) {
          coverages.push({
            name: 'Water Backup',
            cost: application.waterBackup || 0,
          });
        }
        if (application.petDamage) {
          coverages.push({
            name: 'Pet Damage',
            cost: application.petDamage || 0,
          });
        }
        if (application.identityFraud) {
          coverages.push({
            name: 'Identity Fraud',
            cost: application.identityFraud || 0,
          });
        }
        if (application.windHail) {
          coverages.push({
            name: 'Wind Hail',
            cost: application.windHail || 0,
          });
        }
        if (application.earthquake) {
          coverages.push({
            name: 'Earthquake',
            cost: (application.earthquake) || 0
          });
        }
        if (application.hurricane) {
          coverages.push({
            name: 'Hurricane',
            cost: application.hurricane || 0
          });
        }

        const peopleInPolicy: any = [];

        if (firstName) {
          peopleInPolicy.push({
            name: `${firstName} ${lastName ? lastName : ''}`,
            email,
            phone,
          });
        }

        let additionalInsuredRoommates: any[] = [];
        let additionalInterests: any[] = [];
        if (Array.isArray(application.additionalInsuredRoommates)) {
          additionalInsuredRoommates =
            application.additionalInsuredRoommates.map((a) => ({
              name: `${a.firstName || ''} ${a.lastName || ''}`,
              email: a.email,
            }));
        }
        if (Array.isArray(application.additionalInterests)) {
          additionalInterests = application.additionalInterests.map((a) => ({
            name: `${a.firstName || ''} ${a.lastName || ''}`,
            email: a.email,
          }));
        }
        setDetailInfo({
          id: '',
          COMPANY_VENDOR,
          propertyName: buildingName || '',
          address: address || buildingAddress?.value,
          buildingUnit,
          peopleInPolicy,
          forSideBar: true,
          coverageStartDate:
            application.coverageStart && formatDate(application.coverageStart),
          coverages: application.personalPropertyCoverage
            ? coverages
            : undefined,
          additionalInsuredRoommates,
          additionalInterests,
        });
      }
    } catch (error) {
      console.log('Sidebar Component error: ', error);
    }
  }, [application]);

  return (
    <>
      <MuiBox marginLeft={3}>
        {detailInfo && (
          <PaymentReviewDetails
            {...detailInfo}
            addressLogo={logo}
          ></PaymentReviewDetails>
        )}
      </MuiBox>
    </>
  );
};

export default Sidebar;
